'use strict';

export const formWithPaymentSubmitElements = id => ({
    form: document.querySelector(`form#${id}`)
});
